import React from 'react';
import IconProps from '../../icons';

const ZoomLogo = ({ width = 32, className = '' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      className={className}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='32'
        height='32'
        rx='7'
        fill='#4087FC'
      />
      <path
        d='M9.98519 11.4929C9.44108 11.4929 9 11.9733 9 12.566V17.7707C9 19.282 10.1248 20.5072 11.5122 20.5072L17.3481 20.4535C17.8923 20.4535 18.3333 19.9731 18.3333 19.3804V14.1221C18.3333 12.6107 16.9986 11.4929 15.6111 11.4929L9.98519 11.4929Z'
        fill='white'
      />
      <path
        d='M19.665 13.5418C19.313 13.878 19.1111 14.3633 19.1111 14.8732V17.0512C19.1111 17.5612 19.313 18.0464 19.665 18.3826L21.8557 20.2461C22.3015 20.6718 23 20.327 23 19.6813V12.3456C23 11.6998 22.3015 11.355 21.8557 11.7807L19.665 13.5418Z'
        fill='white'
      />
    </svg>
  );
};

export default ZoomLogo;
